import { isNumber } from 'utils/validate';

export const toMillion = (n?: number | string | null) => {
  if (!n) {
    return '';
  }
  const value = +n;

  if (!isNumber(value) || value < 1) {
    return '';
  }
  let formattedValue: string;
  if (value < 1000) {
    // less than a thousand
    formattedValue = Math.round(value).toString();
  } else if (value < 1000000) {
    // less than a million
    formattedValue = `${parseFloat((value / 1000).toFixed(2))}k`;
  } else {
    // million or more
    formattedValue = `${parseFloat((value / 1000000).toFixed(2))}m`;
  }

  return `$${formattedValue}`;
};

export const formatPrice = (n?: number | string | null) => {
  // create price formatter from number or string
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return n ? formatter.format(+n) : '';
};

export const formatProjectCost = (n?: number | string | null) => {
  if (!n) return '';

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return formatter.format(+n);
};
